import styled from '@emotion/styled';
import {
  OL_COLOUR_BLACK_55,
  OL_COLOUR_BLACK_90,
} from '../../../components/Style/colours';

export const LabelHeading = styled('h2')({
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '19px',
  color: OL_COLOUR_BLACK_90,
  marginTop: '20px',
});

export const ContentWrapper = styled('div')({
  marginTop: 20,
});

export const InputWrapper = styled('div')({
  display: 'flex',
  alignItems: 'baseline',
  marginRight: '0.5em',
  marginTop: '0.3em',
  'input[type="checkbox"]': {
    margin: '0 5px',
    position: 'relative',
    top: 5,
  },
});

export const LabelDescription = styled('span')({
  color: OL_COLOUR_BLACK_55,
});
